<template>
  <ui-chip :tone="tone" :dot="!user.suspended" :icon="user.suspended ? 'mdi-cancel' : ''" :title="user.suspended ? user.reason : null">{{ statusText(user) }}</ui-chip>
</template>

<script>
import hasTeamLabels from "../hasTeamLabels";

/** Oznaka statusa: aktivan (zeleno), neaktivan (sivo), suspendovan (crveno, sa razlogom). */
export default {
  name: "TeamStatus",
  mixins: [hasTeamLabels],
  props: { user: { type: Object, required: true } },
  computed: {
    tone() {
      if (this.user.suspended) return "bad";
      return this.user.active ? "ok" : "plain";
    },
  },
};
</script>
